import { LOCALES, LocaleType } from '../../constants/localeConstants';

/**
 * Validates if a given locale is supported, falling back to a safe default.
 *
 * @param {string} locale - Locale provided by the developer (string input)
 * @returns {LocaleType} A valid locale type.
 */
export const getValidLocale = (locale?: string): LocaleType => {
  return Object.values(LOCALES).includes(locale as LocaleType) ? (locale as LocaleType) : LOCALES.EN_US;
};
